import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './ListItem.scss.js';

const bem = Bem.create("vai-list-item");
const ListItem = React.forwardRef(({ disabled, children, className, htmlId, dataTa, ...rest }, ref) => {
  const id = useId(htmlId, ["list-item"]);
  const listItemClassNames = addClass(bem.block(disabled && "disabled"), className);
  return /* @__PURE__ */ React.createElement("li", {
    className: listItemClassNames,
    id: id.toString(),
    "data-ta": dataTa,
    ref,
    ...rest
  }, children);
});

export { ListItem };
